module.exports = __webpack_public_path__ + "static/media/5_store@2x.6ea982d8.jpg";